// main components
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

// mui components
import { Card, Button, CardContent, Grid, Typography, Box } from '@mui/material'

/** Redux */
import { useSelector } from 'react-redux'

/** Services **/
import { UpdateAccountInfo } from './UpdateAccountInfo'
import { getManagementRoles } from '../../lib/Api'

/** Styles **/
import { AccountInfoCardClasses } from '../../styles/classes/AccountSettingsClasses'
import { formatPhoneNumber } from '../../lib/Global'

export const AccountInfoCard = props => {
  const { classes } = AccountInfoCardClasses()
  const { t } = useTranslation()
  const user = useSelector(state => state.auth.user)
  const userRole = useSelector(state => state.auth.userRole)
  const [editDrawer, setEditDrawer] = useState(false)
  const [userInfo, setUserInfo] = useState(JSON.parse(JSON.stringify(user)))
  const [roles, setRoles] = useState()
  const [firstLoad, setFirstLoad] = useState(true)

  useEffect(() => {
    getRoles()
  }, [firstLoad, userInfo])

  const getRoles = async () => {
    try {
      if (firstLoad) {
        const response = await getManagementRoles()

        if (response) {
          setRoles(response)
        }
        setFirstLoad(false)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleClosePanel = u => {
    setEditDrawer(false)
    setUserInfo(u)
  }

  return (
    <div>
      <UpdateAccountInfo
        editDrawer={editDrawer}
        handleClosePanel={handleClosePanel}
        accountInfo={userInfo}
        roles={roles}
      />
      <Card
        className={classes.card}
        data-testid={'account_info_card'}
        elevation={0}
      >
        <Box className={classes.box}>
          <Typography className={classes.title}>
            {t('account_settings.info_card.title')}
          </Typography>
          <Button
            disabled={editDrawer}
            size="small"
            onClick={() => {
              setEditDrawer(true)
            }}
            className={classes.editButton}
          >
            <Typography>
              {t('account_settings.info_card.edit_button')}
            </Typography>
          </Button>
        </Box>

        <CardContent className={classes.content}>
          <Grid container>
            <Grid item xs={3.5}>
              <Typography className={classes.field}>
                {t('account_settings.info_card.first_name')}
              </Typography>
              <Typography
                className={
                  userInfo?.userInfo?.firstName
                    ? classes.namesInfo
                    : classes.infoEmpty
                }
                mt={1}
              >
                {userInfo?.userInfo?.firstName
                  ? userInfo?.userInfo?.firstName
                  : t('account_settings.info_card.placeholder_first')}
              </Typography>
            </Grid>
            <Grid item xs={3.5} ml={2}>
              <Typography className={classes.field}>
                {t('account_settings.info_card.last_name')}
              </Typography>
              <Typography
                className={
                  userInfo?.userInfo?.lastName
                    ? classes.namesInfo
                    : classes.infoEmpty
                }
                mt={1}
              >
                {userInfo?.userInfo?.lastName
                  ? userInfo?.userInfo?.lastName
                  : t('account_settings.info_card.placeholder_last')}
              </Typography>
            </Grid>
            <Grid item xs={3.5} ml={2}>
              <Typography classes={{ root: classes.field }}>
                {t('account_settings.info_card.employee_id')}
              </Typography>
              <Typography
                classes={{
                  root: userInfo?.userInfo?.employee_id
                    ? classes.info
                    : classes.infoEmpty
                }}
                mt={1}
              >
                {userInfo?.userInfo?.employee_id
                  ? userInfo?.userInfo?.employee_id
                  : t('account_settings.info_card.placeholder_employee')}
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={8.2}>
              <Typography className={classes.field}>
                {t('account_settings.info_card.email')}
              </Typography>
              <Typography
                className={
                  userInfo?.userInfo?.email ? classes.info : classes.infoEmpty
                }
                mt={1}
              >
                {userInfo?.userInfo?.email
                  ? userInfo?.userInfo?.email
                  : t('account_settings.info_card.placeholder_email')}
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={4}>
              <Typography className={classes.field}>
                {t('account_settings.info_card.user_title')}
              </Typography>
              <Typography
                className={
                  userInfo?.userInfo?.role ? classes.info : classes.infoEmpty
                }
                mt={1}
              >
                {userInfo?.userInfo?.role
                  ? t('request_access.user_roles.' + userInfo?.userInfo?.role)
                  : t('account_settings.info_card.placeholder_select')}
              </Typography>
            </Grid>
            <Grid item xs={4} ml={2}>
              <Typography className={classes.field}>
                {t('account_settings.info_card.phone_number')}
              </Typography>
              <Typography
                className={
                  userInfo?.userInfo?.phone ? classes.info : classes.infoEmpty
                }
                mt={1}
              >{`${
                userInfo?.userInfo?.phone
                  ? formatPhoneNumber(userInfo?.userInfo?.phone)
                  : t('account_settings.info_card.placeholder_phone')
              }`}</Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={4}>
              <Typography className={classes.field}>
                {t('account_settings.info_card.access')}
              </Typography>
              <Typography
                className={!userRole?.name ? classes.infoEmpty : classes.info}
                mt={1}
              >
                {!userRole?.name
                  ? t('account_settings.info_card.placeholder_select')
                  : userRole.name}
              </Typography>
            </Grid>
            <Grid item xs={4} ml={2}>
              <Typography className={classes.field}>
                {t('account_settings.info_card.password')}
              </Typography>
              <Typography className={classes.passwordInfo} mt={1}>
                {'***********'}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  )
}
